module.exports = __webpack_public_path__ + "img/ring_r_c_1_0.73dcb902.png";